import Vue from 'vue'
import Vuex from 'vuex'

import api_calls from '@/modules/api_calls'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggedIn: false
  },
  getters: {
    login: state => {
      return state.loggedIn
    }
  },
  mutations: {
  },
  actions: {
    async validateState(context) {
      let loggedData = window.sessionStorage.getItem('loggedIn') || null
      loggedData == null ? context.loggedIn = false : context.loggedIn = true
    },

    /*PÁGINAS ATIVAS*/
    async collectPages() {
      let method = "simulador/consumidor/listar"
      let data = await api_calls.call_api_get(method)

      // app.pages = Object.values(data.pages)
      return data;
    },

    /*PÁGINAS INATIVAS*/
    async listarLeadsFormularios() {
      let method = "formularios/listar"
      let data = await api_calls.contactadoFormularios(method)
      return data;
    },

    async contactadoSimuladores(_ , id) {
      let method = "simulador/contactado"
      let data = await api_calls.call_api_post(method, id)
      return data;
    },
    async contactadoSimuladoresReverter(_ , id) {
      let method = "simulador/contactado/reverter"
      let data = await api_calls.call_api_post(method, id)
      return data;
    },
  },
})
